module.exports = __webpack_public_path__ + "static/sport/logo-title.bf4c79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/logo-title.png
// module id = p/PV
// module chunks = 0